const MonitorIcon = () => {
	return (
		<svg
			width="41"
			height="36"
			viewBox="0 0 41 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.75 36V33H17.05V28H3.05005C2.25005 28 1.55005 27.7 0.950048 27.1C0.350048 26.5 0.0500488 25.8 0.0500488 25V3C0.0500488 2.2 0.350048 1.5 0.950048 0.9C1.55005 0.3 2.25005 0 3.05005 0H37.05C37.85 0 38.5501 0.3 39.1501 0.9C39.75 1.5 40.05 2.2 40.05 3V25C40.05 25.8 39.75 26.5 39.1501 27.1C38.5501 27.7 37.85 28 37.05 28H23.05V33H27.35V36H12.75Z"
				fill="#000046"
			/>
		</svg>
	);
};

export default MonitorIcon;
